export const BASE_API_URL = process.env.REACT_APP_BASE_API_URL || "http://localhost:8000/api";
export const BASE_WS_URL = process.env.REACT_APP_BASE_WS_URL || "ws://localhost:8000/ws/event/";
export const STRIPE_PUBLISHABLE_KEY = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;

export const DayOfWeek = {
    0: 'Monday',
    1: 'Tuesday',
    2: 'Wednesday',
    3: 'Thursday',
    4: 'Friday',
    5: 'Saturday',
    6: 'Sunday'
};